export const JourneyFeatures: any = {
  // TODO: this is used in analytics-shouldn't be here
  policy: {
    name: 'policy',
    path: 'policy',
  },
  quote: {
    name: 'quote',
    path: 'quote',
  },
  amendPolicy: {
    name: 'amendPolicy',
    path: 'amend-policy',
  },
  loadPolicy: {
    name: 'loadPolicy',
    path: 'load',
  },
  billing: {
    name: 'billing',
    path: 'billing',
  },
  retrieveQuote: {
    name: 'retrieveQuote',
    path: 'retrieve',
  },
  dashboard: {
    name: 'dashboard',
    path: 'dashboard',
  },
  changeType: {
    name: 'changeType',
    path: 'dashboard/change-type',
  },
  changeDate: {
    name: 'changeDate',
    path: 'dashboard/change-date',
  },
  dashboardSelect: {
    name: 'dashboardSelect',
    path: 'dashboard/select',
  },
  dashboardUpdate: {
    name: 'dashboardUpdate',
    path: 'dashboard/update',
  },
  renewalPreference: {
    name: 'renewalPreference',
    path: 'renewal-preference',
  },
  yourCar: {
    name: 'yourCar',
    path: 'your-car',
  },
  yourCarPerm: {
    name: 'yourCarPerm',
    path: 'your-car/permanent',
  },
  yourCarTemp: {
    name: 'yourCarTemp',
    path: 'your-car/temporary',
  },
  yourTemporaryEuropeanCover: {
    name: 'yourTemporaryEuropeanCover',
    path: 'your-temporary-european-cover',
  },
  yourMileage: {
    name: 'yourMileage',
    path: 'your-mileage',
  },
  yourAddresses: {
    name: 'yourAddresses',
    path: 'your-addresses',
  },
  yourAddress: {
    name: 'yourAddress',
    path: 'your-addresses/address',
  },
  yourPostalAddress: {
    name: 'yourPostalAddress',
    path: 'your-addresses/postal',
  },
  yourDetails: {
    name: 'yourDetails',
    path: 'your-details',
  },
  yourLicenceNumber: {
    name: 'yourLicenceNumber',
    path: 'your-details/driving-licence-number',
  },
  yourDrivingHistory: {
    name: 'yourDrivingHistory',
    path: 'your-details/driving-history',
  },
  yourDrivers: {
    name: 'yourDrivers',
    path: 'your-drivers',
  },
  yourDriversDetails: {
    name: 'yourDriversDetails',
    path: 'your-drivers/details',
  },
  yourDriversPerm: {
    name: 'yourDriversPerm',
    path: 'your-drivers/permanent',
  },
  yourDriversTemp: {
    name: 'yourDriversTemp',
    path: 'your-drivers/temporary',
  },
  yourDriversMoreInfo: {
    name: 'yourDriversMoreInfo',
    path: 'your-drivers/more-info',
  },
  yourRegistration: {
    name: 'yourRegistration',
    path: 'your-registration',
  },
  addDriver: {
    name: 'addDriver',
    path: 'add-driver',
  },
  editDriver: {
    name: 'editDriver',
    path: 'edit-driver',
  },
  personalDetails: {
    name: 'personalDetails',
    path: 'your-drivers/manage/personal-details',
  },
  drivingLicenseNumber: {
    name: 'drivingLicenseNumber',
    path: 'your-drivers/manage/driving-license-number',
  },
  drivingHistory: {
    name: 'drivingHistory',
    path: 'your-drivers/manage/driving-history',
  },
  chooseMainDriver: {
    name: 'chooseMainDriver',
    path: 'your-drivers/manage/choose-main-driver',
  },
  premium: {
    name: 'premium',
    path: 'premium',
  },
  review: {
    name: 'review',
    path: 'review',
  },
  reviewFull: {
    name: 'reviewFull',
    path: 'review/full',
  },
  reviewDirectDebit: {
    name: 'reviewDirectDebit',
    path: 'review/direct-debit',
  },
  payment: {
    name: 'payment',
    path: 'payment',
  },
  directDebitDisplay: {
    name: 'directDebitDisplay',
    path: 'direct-debit-display',
  },
  directDebitEdit: {
    name: 'directDebitEdit',
    path: 'direct-debit-edit',
  },
  directDebitNew: {
    name: 'directDebitNew',
    path: 'direct-debit-new',
  },
  directDebitReview: {
    name: 'directDebitReview',
    path: 'direct-debit-review',
  },
  prefferedPaymentDate: {
    name: 'prefferedPaymentDate',
    path: 'preferred-payment-date',
  },
  creditCard: {
    name: 'creditCard',
    path: 'credit-card',
  },
  refund: {
    name: 'refund',
    path: 'refund',
  },
  confirm: {
    name: 'confirm',
    path: 'confirm',
  },
  confirmFull: {
    name: 'confirmFull',
    path: 'confirm/full',
  },
  confirmDirectDebit: {
    name: 'confirmDirectDebit',
    path: 'confirm/direct-debit',
  },
  confirmAutoRenewal: {
    name: 'confirmAutoRenewal',
    path: 'confirm/renewal-type',
  },
  errors: {
    name: 'errors',
    path: 'errors',
  },
  allocate: {
    name: 'allocate',
    path: 'allocate',
  },
  yourConvictions: {
    name: 'yourConvictions',
    path: 'your-convictions',
  },
  yourVehicleUsage: {
    name: 'yourVehicleUsage',
    path: 'you-vehicle-usage',
  },
  whereIparkMyCar: {
    name: 'whereIparkMyCar',
    path: 'where-i-park-my-car',
  },
  parkingDetails: {
    name: 'parkingDetails',
    path: 'your-addresses/parking-details',
  },
  cancellation: {
    name: 'cancel',
    path: 'cancel',
  },
  cancelPolicy: {
    name: 'cancelPolicy',
    path: 'cancel/policy',
  },
  anotherReason: {
    name: 'anotherReason',
    path: 'cancel/another-reason',
  },
};
